import moment from "moment";
export default {
    methods: {
        exportCsv: function (csvContent, name) {
            var csvData = new Blob([csvContent], { type: 'text/csv' }); //new way
            var csvUrl = URL.createObjectURL(csvData);

            var link = document.createElement("a");
            link.setAttribute("style", "overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;");
            link.setAttribute("href", csvUrl);
            link.setAttribute("download", name + "_" + moment().format('YYYY_MM_DD') + ".csv");
            link.innerHTML = "Click Here to download";
            document.body.appendChild(link); // Required for FF

            link.click();
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/mainMixin.js